import { render, staticRenderFns } from "./selectCategory.vue?vue&type=template&id=4a67a03d&"
import script from "./selectCategory.vue?vue&type=script&lang=js&"
export * from "./selectCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports